import { render, staticRenderFns } from "./FormSubmissionTable.vue?vue&type=template&id=2611aa38&"
import script from "./FormSubmissionTable.vue?vue&type=script&lang=js&"
export * from "./FormSubmissionTable.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmissionTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports